import React from 'react';
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import BannerSection from '../../components/BannerSection';
import SidebarMenu from '../../components/SidebarMenu';
import SectionHeading from '../../components/SectionHeading';
import BreadcrumbNav from '../../components/BreadcrumbNav';
import { Button, Card } from 'react-bootstrap';
import { FaFilePdf, FaExternalLinkAlt } from 'react-icons/fa';

// Importar documentos (ajuste os caminhos conforme necessário)
import Decreto162 from '../../assets/documents/decreto-presidencial-n-o-162-22-de-21-de-junho.pdf';
import Decreto168 from '../../assets/documents/decreto-presidencial-n-o-168-12-de-24-de-julho.pdf';
import Decreto191 from '../../assets/documents/decreto-presidencial-n-o-191-18-de-08-de-agosto.pdf';
import Decreto193 from '../../assets/documents/decreto-presidencial-n-o-193-18-de-10-de-agosto.pdf';
import Decreto256 from '../../assets/documents/decreto-presidencial-n-o-256-21-de-21-de-outubro.pdf';
import Decreto261 from '../../assets/documents/decreto-presidencial-n-o-261-21-de-03-de-novembro.pdf';
import EstatutoDocente from '../../assets/documents/EstatutoCarreiraDocenteEnsinoSuperior_191_18.pdf';
import NormasCurriculares from '../../assets/documents/normas_curriculares_gerais_para_os_cursos_de_po_s-graduac_a_o_do_subsistema_de_ensino_superior.pdf';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Instituição' },
    { label: 'Decretos' }
];

const decretos = [
    {
        id: 1,
        titulo: "Decreto Presidencial Nº 162/22",
        descricao: "De 21 de Junho - Legalização da Instituição",
        arquivo: Decreto162,
        categoria: "Legalização",
        data: "21/06/2022",
        numero: "162/22"
    },
    {
        id: 2,
        titulo: "Decreto Presidencial Nº 168/12",
        descricao: "De 24 de Julho - Legalidade da Instituição",
        arquivo: Decreto168,
        categoria: "Legalização",
        data: "24/07/2012",
        numero: "168/12"
    },
    {
        id: 3,
        titulo: "Decreto Presidencial Nº 191/18",
        descricao: "De 08 de Agosto - Estatuto da Carreira Docente do Ensino Superior",
        arquivo: Decreto191,
        categoria: "Recursos Humanos",
        data: "08/08/2018",
        numero: "191/18"
    },
    {
        id: 4,
        titulo: "Decreto Presidencial Nº 193/18",
        descricao: "De 10 de Agosto - Regulamento Geral das Instituições de Ensino Superior",
        arquivo: Decreto193,
        categoria: "Regulamentação",
        data: "10/08/2018",
        numero: "193/18"
    },
    {
        id: 5,
        titulo: "Decreto Presidencial Nº 256/21",
        descricao: "De 21 de Outubro - Actualização do Quadro Legal",
        arquivo: Decreto256,
        categoria: "Actualização",
        data: "21/10/2021",
        numero: "256/21"
    },
    {
        id: 6,
        titulo: "Decreto Presidencial Nº 261/21",
        descricao: "De 03 de Novembro - Regime Jurídico das IES",
        arquivo: Decreto261,
        categoria: "Jurídico",
        data: "03/11/2021",
        numero: "261/21"
    },
    {
        id: 7,
        titulo: "Estatuto da Carreira Docente",
        descricao: "Estatuto da Carreira Docente do Ensino Superior - Decreto 191/18",
        arquivo: EstatutoDocente,
        categoria: "Recursos Humanos",
        data: "08/08/2018",
        numero: "191/18"
    },
    {
        id: 8,
        titulo: "Normas Curriculares Gerais",
        descricao: "Normas curriculares gerais para os cursos de pós-graduação",
        arquivo: NormasCurriculares,
        categoria: "Acadêmico",
        data: "10/08/2018",
        numero: "193/18"
    }
];

function DecretosRegulamentos() {
    const abrirDocumento = (arquivo) => {
        window.open(arquivo, '_blank', 'noopener,noreferrer');
    };

    return (
        <div>
            <header id='header'>
                <AppHeader />
            </header>
            <BannerSection
                title="Quadro Legal e Normativo"
                subtitle="Decretos Presidenciais e Instrumentos Jurídicos"
                description={`Consulte toda a documentação legal que rege o funcionamento do Instituto Superior Politécnico Atlântida, incluindo decretos presidenciais, estatutos e normativas que garantem a conformidade com a legislação angolana do ensino superior.`}
                backgroundImage={require('../../assets/BannerANU_ispa.jpg')} 
                backgroundId="instituition-Banner"
            />
            <BreadcrumbNav items={caminho} />
            
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
                <br />
                
                <div className="row flex-row-reverse">
                    <div className="col-12 col-md-4 col-lg-3 col-xl-2">
                        <SidebarMenu
                            title="Instituição"
                            items={[
                            { label: "Apresentação", href: "/instituicao" },
                            { label: "Palavras do Presidente", href: "/instituicao/palavra-do-presidente" },
                            { label: "Organigrama", href: "/instituicao/organigrama" },
                            { label: "Legalidade", href: "/instituicao/legalidade" },
                            { label: "Missão, Visão e Valores", href: "/instituicao/missao-visao-valores" },
                            { label: "Apoio Social", href: "/instituicao/apoio-social" },
                            { label: "Perguntas Frequentes", href: "/instituicao/perguntas-frequentes" },
                            { label: "Decretos", href: "/instituicao/decretos" },
                            { label: "Regulamento", href: "/instituicao/regulamentos" },
                            ]}
                        />
                        </div>
                    <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                        <br />
                        
                        <div className="details-magazine">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <SectionHeading title="Instrumentos Legais" />
                            </div>
                            
                            <p className="text-muted mb-4">
                                O Instituto Superior Politécnico Atlântida opera sob um enquadramento jurídico completo, com todos os instrumentos legais necessários para o seu funcionamento regular. Abaixo encontrará a lista completa de decretos presidenciais e documentos normativos que regulamentam as nossas atividades.
                            </p>

                            {/* Lista de Decretos */}
                            <div className="decretos-list">
                                {decretos.map((decreto) => (
                                    <Card key={decreto.id} className="mb-4 border-0 shadow-sm hover-shadow">
                                        <Card.Body className="p-4">
                                            <div className="row align-items-center">
                                                <div className="col-md-8">
                                                    <div className="d-flex align-items-center mb-2">
                                                        <small className="text-muted">
                                                            <FaFilePdf className="text-danger me-1" />
                                                            PDF • {decreto.data}
                                                        </small>
                                                    </div>
                                                    <h5 className="mb-2 fw-bold" style={{color:'#00731f'}}>
                                                        {decreto.titulo}
                                                    </h5>
                                                    <p className="text-muted mb-3">
                                                        {decreto.descricao}
                                                    </p>
                                                    <small className="text-muted">
                                                        Nº: {decreto.numero}
                                                    </small>
                                                </div>
                                                <div className="col-md-4 text-md-end">
                                                    <Button 
                                                        variant="primary" 
                                                        onClick={() => abrirDocumento(decreto.arquivo)}
                                                        size="lg"
                                                        className="w-100 w-md-auto mt-3 mt-md-0"
                                                    >
                                                        <FaExternalLinkAlt className="me-2" />
                                                        Visualizar Documento
                                                    </Button>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                ))}
                            </div>
                        </div>
                        <br /><br />
                    </div>
                </div>
                <br /><br /><br /><br /><br />
            </main>

            <AppLayout />
        </div>
    );
}

export default DecretosRegulamentos;